<template>
<div class="limited-width-box">
  <v-card class="is-fullheight flex flex-column white-common-box">
    <div>
      
      
      <div class="pa-5 flex flex-column">
        <div class="title-font mainColor--text box-title-label">
          Change account email
        </div>

        <div class="notify-label">
          <i class="material-icons">error_outline</i>
          You will receive a verification email
        </div>

        <v-text-field dense
          type="password"
          label="Your password"
          color="greenColor"
          v-model="password"
          hide-details="auto"
          outlined
        ></v-text-field>

        <v-text-field dense
          hide-details="auto"
          label="New email"
          color="greenColor"
          v-model="newEmail"
          outlined
        ></v-text-field>
        <div>
          <v-btn rounded
            color="lightGreenColor"
            class="button-with-icon text-none white--text" @click="updateEmail" :disabled="!isReadyToChangeEmail">
            Change email
          </v-btn>
        </div>
      </div>
    </div>
  </v-card>

  <v-card v-if="isWhiteGloveUser" class="is-fullheight flex flex-column white-common-box mt-10">
    <div>

      <div class="pa-5 flex flex-column">
        <div class="title-font mainColor--text box-title-label">
          {{ $store.getters.whiteGloveFamilyProgramName }} notifications email
        </div>

        <div class="mt-5 mb-5">
          You can use a separate email address for receiving {{ $store.getters.whiteGloveFamilyProgramName }} service notifications
        </div>

        <v-text-field dense
          hide-details="auto"
          :label="`Insert an email address for ${$store.getters.whiteGloveFamilyProgramName} notifications`"
          color="greenColor"
          v-model="notificationEmail"
          outlined
        ></v-text-field>

        <v-radio-group v-model="notificationEmailsMode" class="mt-0">
          <v-radio
            label="Send notifications to the main account email and CC to the notifications email"
            value="cc"
          ></v-radio>
          <v-radio
            label="Send notifications to the notifications email only"
            value="to"
          ></v-radio>
        </v-radio-group>

        <div>
          <v-btn rounded
            color="profileAnchorColor"
            class="button-with-icon text-none white--text" @click="saveNotificationEmailSettings">
            Save
          </v-btn>
        </div>
      </div>
    </div>
  </v-card>
</div>
</template>

<script>
import validator from "validator";

import { getPureServicePkgName } from '@/utils'
import { whiteGlovePlans } from "@/components/plans_constants"

export default {
  data () {
    return {

      password: '',
      newEmail: '',

      notificationEmail: null,
      notificationEmailsMode: 'cc',
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    isReadyToChangeEmail () {
      return this.password && this.newEmail && this.newEmail != this.user.email
    },
    isWhiteGloveUser () {
      if (!this.user) return false;

      if (whiteGlovePlans.includes(getPureServicePkgName(this.user.accountType))) {
        return true;
      }
      return false;
    },
  },
  methods: {
    updateEmail () {
      console.log('Performing update email action')

      let data = {
        currentEmail: this.user.email,
        newEmail: this.newEmail,
        password: this.password
      }
      this.$store.commit('showLoading')
      this.$store.dispatch('changeEmailRequest', data)
      .then(response => {
        if (response.data && response.data.status == 'SUCCESS') {
          window.alert('Confirmation email sent.  Please check your new email\'s inbox.')
          this.logout()
        } else {
          if (response.data.msg)           {
            window.alert(response.data.msg)
          }
        }
      })
      .finally(() => {
        this.$store.commit('hideLoading')
      })
    },
    logout () {
      this.$store.commit('clearStore')
      this.$router.push('/login')
    },
    saveNotificationEmailSettings () {
      if (this.notificationEmail) {
        if (!validator.isEmail(this.notificationEmail)) {
          this.$notify({
            group: 'info', type: 'error',
            text: 'Please input valid email'
          })
          return
        }
      }
      this.$store.commit('showLoading')
      this.$store.dispatch('saveEmailSettings', {
        notificationEmails: [this.notificationEmail],
        notificationEmailsMode: this.notificationEmailsMode,
      })
      .then(response => {
        if (response.data && response.data.status == 'SUCCESS') {
          this.$notify({
            group: 'info', type: 'success',
            text: 'Successfully saved.'
          })
          this.$store.commit('setUser', response.data.user)
        } else {
          this.$notify({
            group: 'info', type: 'error',
            text: 'Failed to save.'
          })
        }
      })
      .finally(() => {
        this.$store.commit('hideLoading');
      })
    },
  },
  mounted() {
    this.notificationEmail = this.user?.notificationEmails?.[0]
    this.notificationEmailsMode = this.user.notificationEmailsMode
  },
  beforeMount () {
    this.newEmail = this.user.email
  }
}

</script>

<style lang="scss" scoped>
* {
  color: var(--v-mainColor-base);
}
.v-input.v-input--hide-details {
  margin-bottom: 24px !important;
}
.theme--light.v-label {
  color: red !important;
  background: blue !important;
  /* opacity: 1; */
}


</style>